import { useNarrow } from '../../lib/use-narrow';
import { useTranslation } from '../../lib/i18n';
import { EmptyState } from './agents/EmptyState';
import { WorkspaceHero } from './WorkspaceHero';
import { WorkspaceSummaryRow } from './WorkspaceSummaryRow';
import { ScrollArea } from './ui';

// The Growth tab's empty state, shown when the workspace has no dashboard yet (Figma 10941-75253): the
// shared hero + tab bar over the General Empty State card — the card-stack glyph + a single label the
// Tasks / Routines / Goals empties already use — instead of the old centered "coming soon" placeholder.
//
// Deliberate, tracked divergence from native: iOS/Android draw their own centered "{Maestro} is still
// putting your dashboard together" text on this tab (and auto-switch off Growth when it's truly empty),
// not the card-stack empty. Scoped web-first here — see orion-web/CLAUDE.md.
export function WorkspaceGrowthEmpty({ slug, page }: { slug: string; page: string }) {
  const { t } = useTranslation();
  const narrow = useNarrow();
  return (
    <ScrollArea
      component="section"
      className="orion-content-pane"
      style={{ position: 'absolute', top: 0, bottom: 0, zIndex: 4, paddingTop: narrow ? 96 : 72, paddingBottom: 48, display: 'flex', flexDirection: 'column' }}
    >
      <WorkspaceHero slug={slug} active="dashboard" page={page} />
      {/* The summary tiles are the tab's OWN content and stay whether or not a dashboard exists yet —
          a Space with routines and tasks but no dashboard is not an empty Space. */}
      <WorkspaceSummaryRow slug={slug} page={page} />
      <EmptyState label={t('workspace.dashboardMissingTitle')} />
    </ScrollArea>
  );
}
